import { render, staticRenderFns } from "./DataDetail.vue?vue&type=template&id=ffd45824&scoped=true"
import script from "./DataDetail.vue?vue&type=script&lang=js"
export * from "./DataDetail.vue?vue&type=script&lang=js"
import style0 from "./DataDetail.vue?vue&type=style&index=0&id=ffd45824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd45824",
  null
  
)

export default component.exports